module.exports = __webpack_public_path__ + "static/media/email.10e8d1db.svg";